export const filterChipGroup = {
  clearAll: {
    en: 'Clear All',
    nb: 'Nullstill',
    nn: 'Nullstill',
  },
  dateRangeFrom: {
    en: 'From',
    nb: 'Fra',
    nn: 'Frå',
  },
  dateRangeTo: {
    en: 'To',
    nb: 'Til',
    nn: 'Til',
  },
} as const;
